export enum SettingsDropdownAction {
    edit_group_name = 'edit_group_name',
    add_new_group = 'add_new_group',
    remove_group = 'remove_group'
}
